import { createApi } from '@reduxjs/toolkit/query/react'
import { url } from 'inspector'
import { authHeaderAPI } from 'redux/_helpers/auth-header'
import { baseQueryWithErrorHandler } from 'redux/_helpers/custom-base-query'

export const ReservationsAPI = createApi({
  reducerPath: 'ReservationsAPI',
  baseQuery: baseQueryWithErrorHandler,
  tagTypes: ['Reservations'],
  endpoints: builder => ({
    postReserveTransportation: builder.mutation({
      query: body => ({
        url: `/api/Reservations/transportation`,
        method: 'POST',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['Reservations'],
    }),
    postReserveFlight: builder.mutation({
      query: body => ({
        url: `/api/Reservations/flight`,
        method: 'POST',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['Reservations'],
    }),
    postReserveHotel: builder.mutation({
      query: body => ({
        url: `/api/Reservations/hotel`,
        method: 'POST',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['Reservations'],
    }),
    postReservePackage: builder.mutation({
      query: body => ({
        url: `/api/Reservations/PackageReservation`,
        method: 'POST',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['Reservations'],
    }),
  }),
})
export const {
  // useGetGroupsQuery,
  usePostReserveTransportationMutation,
  usePostReserveFlightMutation,
  usePostReserveHotelMutation,
  usePostReservePackageMutation,
} = ReservationsAPI
